'use client';
import React, { useState } from 'react';
import styles from './lazy.module.sass';
import cn from 'classnames';
import { Skeleton } from '../Skeleton';

interface LazyImageProps extends React.HTMLAttributes<HTMLImageElement> {
    src?: string | null;
    alt?: string;
    width?: number;
    height?: number;
    // Set on the known LCP / above-the-fold hero image. Everything else can stay lazy.
    priority?: boolean;
}

export const LazyImage = ({ src, alt, width, height, priority, ...props }: LazyImageProps) => {
    const imageSrc = src || undefined;
    const [loaded, setLoaded] = useState(!imageSrc);

    return (
        <div {...props} className={cn(styles.holder, props.className)}>
            {imageSrc ? (
                <img
                    src={imageSrc}
                    alt={alt ?? ''}
                    width={width}
                    height={height}
                    loading={priority ? 'eager' : 'lazy'}
                    fetchPriority={priority ? 'high' : 'auto'}
                    decoding="async"
                    onLoad={() => setLoaded(true)}
                    onError={() => setLoaded(true)}
                    className={cn(
                        styles.lazy,
                        'lazy-load-image',
                        loaded && styles['lazy-load-done'],
                        loaded && 'lazy-load-done'
                    )}
                />
            ) : null}
            {!loaded && <Skeleton />}
        </div>
    );
};
